import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CenteredElementGrid from './CenteredElementGrid';
import ClientProvider from './client';
export default createDemo(import.meta.url, CenteredElementGrid, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/grid/demos/centered-element/CenteredElementGrid.tsx",
    "fileName": "CenteredElementGrid.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Avatar from '@mui/material/Avatar';\nimport Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\n\nexport default function CenteredElementGrid() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Grid container spacing={2} sx={{ minHeight: 160 }}>\n        <Grid\n          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}\n          size=\"grow\"\n        >\n          <Avatar src=\"/static/images/avatar/1.jpg\" />\n        </Grid>\n        <Grid\n          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}\n        >\n          <Avatar src=\"/static/images/avatar/2.jpg\" />\n        </Grid>\n        <Grid\n          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}\n          size=\"grow\"\n        >\n          <Avatar src=\"/static/images/avatar/3.jpg\" />\n        </Grid>\n      </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Avatar from '@mui/material/Avatar';\nimport Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\n\nexport default function CenteredElementGrid() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Grid container spacing={2} sx={{ minHeight: 160 }}>\n        <Grid\n          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}\n          size=\"grow\"\n        >\n          <Avatar src=\"/static/images/avatar/1.jpg\" />\n        </Grid>\n        <Grid\n          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}\n        >\n          <Avatar src=\"/static/images/avatar/2.jpg\" />\n        </Grid>\n        <Grid\n          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}\n          size=\"grow\"\n        >\n          <Avatar src=\"/static/images/avatar/3.jpg\" />\n        </Grid>\n      </Grid>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 29,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Avatar",
      "@mui/material/Box",
      "@mui/material/Grid"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
